import { render } from "./Footer.vue?vue&type=template&id=bdb87366&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=bdb87366&scoped=true&lang=css"

import exportComponent from "/Data/maps/disappearance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb87366"]])

export default __exports__